import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Cúram documentation access is changing to better manage access to detailed product materials. For releases dated July 23, 2026 and later, entitled customers can access documentation through Salesforce / S-Drive alongside their software downloads. Documentation for earlier releases can be requested through Merative Support. The public documentation site will continue to provide announcements, prerequisites, and instructions on how to obtain documentation.`}</p>
    <InlineNotification mdxType="InlineNotification">   
Merative™ Social Program Management is now Cúram™ by Merative™ - Look for upcoming releases under this new name.
    </InlineNotification>
    {
      /* <Row className="resource-card-group">
      <Column colMd={4} colLg={4} noGutterSm>
      <ResourceCard
         color="dark"
         title="Curam Social Program Management"
         subTitle="Product"
         actionIcon="arrowRight"
         href="/spm">
      </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm>
      <ResourceCard
         color="dark"
         title="Watson Care Manager"
         subTitle="Product"
         actionIcon="arrowRight"
         href="/wcm">
      </ResourceCard>
      </Column>
      </Row> */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      